import { axios } from '../request'

export default (_app) => {
  return {
    namespaced: true,
    state: {
      data: [],
      loading: false,
      syncing: false,
      error: null,
    },
    mutations: {
      setData(state, data) {
        state.data = data
      },
      setLoading(state, v) {
        state.loading = v
      },
      setSyncing(state, v) {
        state.syncing = v
      },
      setError(state, v) {
        state.error = v
      },
    },
    actions: {
      async list({ commit }) {
        commit('setLoading', true)
        commit('setError', null)
        try {
          const res = await axios.get('pronobis_transactions', { timeout: 120000 })
          commit('setData', res.data.data || [])
        } catch (err) {
          commit('setError', err.message)
        } finally {
          commit('setLoading', false)
        }
      },
      sync({ commit }) {
        commit('setSyncing', true)
        commit('setError', null)
        // POST returns 204 immediately; progress comes via WebSocket
        axios.post('pronobis_transactions/sync').catch((err) => {
          commit('setError', err.message)
          commit('setSyncing', false)
        })
      },
      syncDone({ commit }) {
        commit('setSyncing', false)
      },
    },
  }
}
